<template>
  <div class="app-root">
    <router-view v-if="showMainContent" />
    <login v-else-if="!isPreviewRoute" @login="isLoggedIn()" />
  </div>
</template>

<script>
import axios from 'axios'
import Login from '@/views/Login'

import 'element-ui/lib/theme-chalk/index.css'

export default {
  components: {
    Login
  },

  data () {
    return {
      loggedIn: null
    }
  },

  computed: {
    isPreviewRoute () {
      return this.$route.name === 'MaterijalPreview'
    },
    showMainContent () {
      return this.loggedIn || this.isPreviewRoute
    }
  },

  created () {
    this.isLoggedIn()
  },

  mounted () {
    this.$root.$on('logout', this.isLoggedIn)
  },

  beforeDestroy () {
    this.$root.$off('logout', this.isLoggedIn)
  },

  methods: {
    isLoggedIn () {
      const token = localStorage.getItem('token')
      if (!token) {
        this.loggedIn = null
        return
      }
      this.loggedIn = true
      axios.get('/api/auth/me').then((res) => {
        this.loggedIn = (res.data && res.data.data) ? true : null
      }).catch(() => {
        this.loggedIn = null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-root {
  height: 100%;
}

nav {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background-color: #fff;
    ul {
      li {
        display: inline-block;
        margin: 0 25px;
        .router-link-exact-active {
          color: $link;
          font-weight: bold;
        }
      }
    }
  }
</style>
